import { useEffect, useRef } from "react";
import { Checkbox, Button, Card, Col, DatePicker, Form, Input, Row, Grid } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { t } from "i18next";
import { useDataGrid } from "../../../core/components/data-grid/DataGridContext";

export default function PatientFilter() {
    const { onFilterPageSort, queryModel } = useDataGrid();
    const formRef = useRef();
    const screens = Grid.useBreakpoint();
    const isMobile = !screens.md;

    useEffect(() => {
        formRef.current?.setFieldsValue({
            validate: true,
            ...queryModel.filter,
        });
    }, [queryModel.updateKey]);

    const onFinish = async (formData) => {
        onFilterPageSort({
            filter: formData
        })
    }

    if (isMobile) {
        return (
            <Form
                size="middle"
                layout="vertical"
                ref={formRef}
                onFinish={onFinish}
                initialValues={{ validate: true }}
                style={{ width: '100%' }}
            >
                <Form.Item name="searchText" style={{ marginBottom: 8 }}>
                    <Input
                        prefix={<SearchOutlined style={{ color: '#bfbfbf' }} />}
                        placeholder={t("Name, Id, Phone ...")}
                        allowClear
                    />
                </Form.Item>

                <Row gutter={8} style={{ marginBottom: 8 }}>
                    <Col span={12}>
                        <Form.Item name="motherName" style={{ marginBottom: 0 }}>
                            <Input placeholder={t("Mother Name")} allowClear />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item name="fatherName" style={{ marginBottom: 0 }}>
                            <Input placeholder={t("Father Name")} allowClear />
                        </Form.Item>
                    </Col>
                </Row>

                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    gap: 8
                }}>
                    <Form.Item
                        name="validate"
                        valuePropName="checked"
                        style={{ marginBottom: 0, flex: 1 }}
                    >
                        <Checkbox>{t("Doğrulanmış Hastalar")}</Checkbox>
                    </Form.Item>

                    <Form.Item style={{ marginBottom: 0 }}>
                        <Button
                            type="primary"
                            icon={<SearchOutlined />}
                            htmlType="submit"
                        >
                            {t("Search")}
                        </Button>
                    </Form.Item>
                </div>
            </Form>
        );
    }

    return (
        <Form
            size="small"
            layout="inline"
            ref={formRef}
            onFinish={onFinish}
            initialValues={{
                validate: true
            }}
        >
            <Form.Item
                name="searchText"
                style={{ marginRight: 12 }}
            >
                <Input
                    placeholder={t("Name, Id, Phone ...")}
                    style={{ width: 200 }}
                />
            </Form.Item>

            <Form.Item
                name="motherName"
                style={{ marginRight: 12 }}
            >
                <Input
                    placeholder={t("Mother Name")}
                    style={{ width: 150 }}
                />
            </Form.Item>

            <Form.Item
                name="fatherName"
                style={{ marginRight: 12 }}
            >
                <Input
                    placeholder={t("Father Name")}
                    style={{ width: 150 }}
                />
            </Form.Item>

            <Form.Item
                name="validate"
                valuePropName="checked"
                style={{ marginRight: 12 }}
            >
                <Checkbox style={{ whiteSpace: "nowrap" }}>
                    {t("Doğrulanmış Hastalar")}
                </Checkbox>
            </Form.Item>

            <Form.Item>
                <Button htmlType={'submit'}>
                    {t("Search")}
                </Button>
            </Form.Item>
        </Form>
    )
}
